import axios from "axios";

export default {
  fetchAll: async () => {
    const response = await axios.get('/api/users');
    return response.data;
  },
  getUser: async userId => {
    const response = await axios.get('/api/users/' + userId);
    return response.data;
  },
  getUserStatistics: async userId => {
    const response = await axios.get('/api/users/' + userId + '/statistics');
    return response.data;
  },
  updateUser: async form => {
    const { data } = await form.patch('/api/users/' + form.id);
    return data;
  },
  createUser: async form => {
    const { data } = await form.post('/api/users/create');
    return data;
  },
  studyLesson: async lessonId => {
    const response = await axios.post('/api/user_lessons/' + lessonId);
    return response.data;
  },
};
